import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { MsalService } from '@azure/msal-angular';
import { Client } from '@microsoft/microsoft-graph-client';

import { ApplicationUser } from './user';
import { environment } from '../environments/environment';

import { HttpClient } from '@angular/common/http';

@Injectable()
export class AuthService {
  public authenticated: boolean;
  public user: ApplicationUser;
  public settings: ServerSettings;

  constructor(
    private msalService: MsalService, 
    private http: HttpClient,
    @Inject('BASE_URL') private baseUrl: string
  ) { 

  }

  async signIn(): Promise<void> {
    console.log('Signing in...');
    const loginRequest = ["User.Read"];
    let result = await this.msalService.loginPopup(/*loginRequest*/);

      console.log('Signed in!');
    if (result) {
      this.authenticated = true;
      this.user = await this.getUser();
      this.settings = await this.getSettings();
    }
    try {
      this.user = await this.getUser();
      console.log("successfully got " + this.user);
      this.authenticated = true;
      this.settings = await this.getSettings();
      console.log("successfully got " + this.settings);
    } catch (error) {
      console.error(error);
    }
  }

  // Sign out
  signOut(): void {
    this.msalService.logout();
    this.user = null;
    this.settings = null;
    this.authenticated = false;
  }

  // Silently request an access token
  async getAccessToken(): Promise<string> {
    let result = await this.msalService.acquireTokenSilent(environment.MSAL.scopes)
      .catch((reason) => {
        console.error(reason);
      });

    return result;
  }

  private async getSettings() : Promise<ServerSettings> {
    if (!this.authenticated) return null;

    let settings = await this.http.get<ServerSettings>(this.baseUrl + 'api/ServerEnvironmentSettings/Get')
      .toPromise();

    return settings;
  }

  private async getUser(): Promise<ApplicationUser> {
    if (!this.authenticated) return null;

    let user = await this.http.get<ApplicationUser>(this.baseUrl + 'api/ApplicationUsers/Register')
      .toPromise();

    return user;
  }
}

interface ServerSettings {

  fiserv: string;
  dataWarehouse: string;
}



// WEBPACK FOOTER //
// ./src/app/auth.service.ts